var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._b({on:{"hidden":function($event){return _vm.$emit('hidden')},"shown":payload => _vm.$emit('shown', payload)},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},'b-modal',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }